module.exports = __webpack_public_path__ + "images/emails/digest/logo-postmark-37a10835.png";